<ng-container *ngIf="isLoadingPermissions; else loaded">
    <ngx-skeleton-loader
        count="5"
        [theme]="{ 
            'height.px': 50
        }"
    ></ngx-skeleton-loader>
</ng-container>
<ng-template #loaded>
    <mat-card class="mat-elevation-z0">
        <mat-card-title class="header">
            <div class="k-d-flex k-d-flex-row k-align-items-center">
                <h2 class="k-flex-grow" appLocalizationPopupDirective localizationCode="Compensation">{{ 'Compensation' | translate: {Default: "Compensation"} }}</h2>
    
                <mat-form-field appearance="fill" class="k-mr-2">
                    <mat-label>
                        {{ 'EffectiveDate' | translate: {Default: "Effective Date"} }}
                    </mat-label>
    
                    <input matInput [matDatepicker]="effectiveDatePicker" (dateChange)="effectiveDateChange($event)" [(ngModel)]="today">
                    <span fxLayout="row" matSuffix>
                        <mat-datepicker-toggle [for]="effectiveDatePicker"></mat-datepicker-toggle>
                    </span>
                    <mat-datepicker #effectiveDatePicker></mat-datepicker>
                </mat-form-field>
    
                <mat-icon 
                    setColor 
                    [setColorRules]="[
                        {
                            color: 'primaryColour',
                            events: ['hover']
                        }
                    ]"
                    aria-hidden="false" 
                    class="material-icons-outlined k-mr-3" 
                    aria-label="View access logs"
                    role="button"
                    tabindex="0"
                    appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openAccessLogsDialog()"
                    (keydown.enter)="openAccessLogsDialog()"
                    (keydown.space)="$event.preventDefault(); openAccessLogsDialog()"
                >
                    fingerprint
                </mat-icon>
                <mat-icon 
                setColor 
                [setColorRules]="[
                    {
                        color: 'primaryColour',
                        events: ['hover']
                    }
                ]"
                aria-hidden="false"
                class="material-icons-outlined k-mr-3" 
                aria-label="View history"
                role="button"
                tabindex="0"
                appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openHistoryDialog()"
                (keydown.enter)="openHistoryDialog()"
                (keydown.space)="$event.preventDefault(); openHistoryDialog()"
                >
                    history
                </mat-icon>
    
                <button
                        mat-raised-button
                        setColor="primaryColour" 
                        color="primary"
                        [disabled]="formValid === false"
                        appPreventDoubleClick 
                        (throttledClick)="getFormData = !getFormData"
                        *appTableAccess="[tableCreateAccessObj, tableUpdateAccessObj]">
                    {{ 'Save' | translate: {Default: "Save"} }}
                </button>
            </div>
        </mat-card-title>
        <mat-card-content>
            <div *ngIf="isLoading">
                <ngx-skeleton-loader
                count="5"
                [theme]="{
                    'height.px': 50
                }"
                ></ngx-skeleton-loader>
            </div>
    
            <div *ngIf="!isLoading">
                <div class="form-section">
                    <div class="form-section-title">
                        <h3 tabindex="0" appLocalizationPopupDirective localizationCode="CalculatedValues">{{ 'CalculatedValues' | translate: {Default: "Calculated Values"} }}</h3>
                    </div>
                    <div class="form-section-contents calculated-fields-container">
    
                        <div class="bottom" appLocalizationPopupDirective localizationCode="CompensationValuesWillBeRecalulated">
                            {{ 'CompensationValuesWillBeRecalulated' | translate: {Default: "These values will be recalulated when you save new values."} }}
                        </div>
    
                        <div class="calculated-fte" *ngIf="calculatedFTE" appLocalizationPopupDirective localizationCode="CalculatedFTE">
                            <span setColor="primaryColour" class="label">{{ 'CalculatedFTE' | translate: {Default: "Calculated FTE"} }}:</span> {{calculatedFTE}}
                        </div>
    
                        <div class="top">
                            <div class="sub-container" *ngIf="salarySystemCurrency && salarySystem" role="group" aria-labelledby="salary-system-label" tabindex="0">
                                <div class="calculated-fields-label" id="salary-system-label" appLocalizationPopupDirective localizationCode="SalarySystem">{{ 'SalarySystem' | translate: {Default: "Salary System"} }}</div>
                                <dl class="calculated-fields-amount" tabindex="0">
                                    <dt setColor="primaryColour" class="type" appLocalizationPopupDirective localizationCode="FullFTE">
                                        {{ 'FullFTE' | translate: {Default: "Full FTE"} }}
                                    </dt>
                                    <dd class="value">
                                        {{salarySystemCurrency | currencyDisplay: salarySystem}}
                                    </dd>
                                </dl>
                                <dl class="calculated-fields-amount" tabindex="0">
                                    <dt setColor="primaryColour" class="type" appLocalizationPopupDirective localizationCode="AdjustedToFTE">
                                        {{ 'AdjustedToFTE' | translate: {Default: "Adjusted To FTE"} }}
                                    </dt>
                                    <dd class="value">
                                        {{salarySystemCurrency | currencyDisplay: salarySystemFteAdjusted}}
                                    </dd>
                                </dl>
                            </div>
    
                            <div class="sub-container" *ngIf="payRateCurrency && baseSalary" role="group" aria-labelledby="base-salary-label" tabindex="0">
                                <div class="calculated-fields-label" id="base-salary-label" appLocalizationPopupDirective localizationCode="BaseSalary">{{ 'BaseSalary' | translate: {Default: "Base Salary"} }}</div>
                                <dl class="calculated-fields-amount" tabindex="0">
                                    <dt setColor="primaryColour" class="type" appLocalizationPopupDirective localizationCode="FullFTE">
                                        {{ 'FullFTE' | translate: {Default: "Full FTE"} }}
                                    </dt>
                                    <dd class="value">
                                        {{payRateCurrency | currencyDisplay: baseSalary}}
                                    </dd>
                                </dl>
                                <dl class="calculated-fields-amount" tabindex="0">
                                    <dt setColor="primaryColour" class="type" appLocalizationPopupDirective localizationCode="AdjustedToFTE">
                                        {{ 'AdjustedToFTE' | translate: {Default: "Adjusted To FTE"} }}
                                    </dt>
                                    <dd class="value">
                                        {{payRateCurrency | currencyDisplay: baseSalaryFteAdjusted}}
                                    </dd>
                                </dl>
                            </div>
    
                            <div class="sub-container" *ngIf="salaryOtherCurrency && salaryOther" role="group" aria-labelledby="salary-other-label" tabindex="0">
                                <div class="calculated-fields-label" id="salary-other-label" appLocalizationPopupDirective localizationCode="SalaryOther">{{ 'SalaryOther' | translate: {Default: "Salary Other"} }}</div>
                                <dl class="calculated-fields-amount" tabindex="0">
                                    <dt setColor="primaryColour" class="type" appLocalizationPopupDirective localizationCode="FullFTE">
                                        {{ 'FullFTE' | translate: {Default: "Full FTE"} }}
                                    </dt>
                                    <dd class="value">
                                        {{salaryOtherCurrency | currencyDisplay: salaryOther}}
                                    </dd>
                                </dl>
                                <dl class="calculated-fields-amount" tabindex="0">
                                    <dt setColor="primaryColour" class="type" appLocalizationPopupDirective localizationCode="AdjustedToFTE">
                                        {{ 'AdjustedToFTE' | translate: {Default: "Adjusted To FTE"} }}
                                    </dt>
                                    <dd class="value">
                                        {{salaryOtherCurrency | currencyDisplay: salaryOtherFteAdjusted}}
                                    </dd>
                                </dl>
                            </div>
    
                            <div class="sub-container" *ngIf="salaryNonGmgCurrency && salaryNonGmg" role="group" aria-labelledby="salary-non-gmg-label" tabindex="0">
                                <div class="calculated-fields-label" id="salary-non-gmg-label" appLocalizationPopupDirective localizationCode="SalaryNonGMG">{{ 'SalaryNonGMG' | translate: {Default: "Salary Non GMG"} }}</div>
                                <dl class="calculated-fields-amount" tabindex="0">
                                    <dt setColor="primaryColour" class="type" appLocalizationPopupDirective localizationCode="FullFTE">
                                        {{ 'FullFTE' | translate: {Default: "Full FTE"} }}
                                    </dt>
                                    <dd class="value">
                                        {{salaryNonGmgCurrency | currencyDisplay: salaryNonGmg}}
                                    </dd>
                                </dl>
                                <dl class="calculated-fields-amount" tabindex="0" appLocalizationPopupDirective localizationCode="AdjustedToFTE">
                                    <dt setColor="primaryColour" class="type">
                                        {{ 'AdjustedToFTE' | translate: {Default: "Adjusted To FTE"} }}
                                    </dt>
                                    <dd class="value">
                                        {{salaryNonGmgCurrency | currencyDisplay: salaryNonGmgFteAdjusted}}
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
    
                <app-form-generator
                    [formId]="formId"
                    [formData]="formData"
                    [emitFormDataTrigger]="getFormData"
                    [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
                    (emitFormData)="formDataEmitted($event)"
                    (emitFormStatus)="formStatusUpdated($event)"
                ></app-form-generator>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>